import {
  AXA_CO_BRANDED_BRANDING_TYPE,
  AXA_LEAD_BRANDING_TYPE,
  PARTNER_CO_BRANDED_BRANDING_TYPE
} from "features/configuration/configuration-constants";
import { selectBrandingType } from "features/configuration/selectors/configuration-selectors";
import { useSelector } from "react-redux";

export const useBranding = () => {
  const partnerBrandingType = useSelector(selectBrandingType);
  const isAxaCoBranded = partnerBrandingType === AXA_CO_BRANDED_BRANDING_TYPE;
  const isPartnerCoBranded =
    partnerBrandingType === PARTNER_CO_BRANDED_BRANDING_TYPE;
  const isAxaLead = partnerBrandingType === AXA_LEAD_BRANDING_TYPE;

  return { isAxaCoBranded, isAxaLead, isPartnerCoBranded };
};
